import { computed, watch } from '@vue/composition-api';
import type { ComputedRef, Ref } from '@vue/composition-api';
import type {
  HokkaidoAirportSettings,
} from '@/models/apis/externalReports/hokkaidoAirport/hokkaidoAirportSettings';
import {
  getInspectionCarTypes,
  initInspectionResults,
  isAllInspectionCompleted,
} from '@/lib/externalReports/hokkaidoAirportInspection';
import type { InspectionInputState } from '@/components/Sp/ExternalReports/HokkaidoAirport/types';

interface UseInspectionInputResult {
  hasVehicleSelection: ComputedRef<boolean>;
  isAllInspected: ComputedRef<boolean>;
}

export const useInspectionInput = (
  userSettings: Ref<HokkaidoAirportSettings>,
  input: InspectionInputState,
): UseInspectionInputResult => {
  const hasVehicleSelection = computed<boolean>(() => !!input.selectedAirport && !!input.selectedCarType);
  const isAllInspected = computed<boolean>(() => {
    return isAllInspectionCompleted(
      userSettings.value.inspection,
      input.selectedAirport,
      input.selectedCarType,
      input.inspectionResults,
    );
  });

  // 空港・車種を変えたら、別車種の入力が残らないよう点検結果を作り直す
  watch(() => [input.selectedAirport, input.selectedCarType], () => {
    if (!hasVehicleSelection.value) {
      input.inspectionResults = {};
      return;
    }

    const master = userSettings.value.inspection;
    input.inspectionResults = initInspectionResults(
      getInspectionCarTypes(master, input.selectedAirport, input.selectedCarType),
    );
  }, { immediate: true });

  return { hasVehicleSelection, isAllInspected };
};
